import { RootState } from "../../../reducers";
import { useSelector } from "react-redux";
import { Indicator, IndicatorContainer, KeyList, Container } from "./styles";

function KeyDescription() {
  const filterStore = useSelector((state: RootState) => state.filter);

  const getKeyIndicators = (marketType: string) => {
    const defaultIndicators = [
      {
        name: "won",
        id: "w",
      },
      {
        name: "lost",
        id: "l",
      },
    ]

    if (marketType !== 'ML') {
      return [...defaultIndicators, {
        name: "push",
        id: "p",
      },]
    }

    return defaultIndicators;
  };

  return (
    <Container>
      <KeyList role="list">
        {getKeyIndicators(filterStore.market)?.map(($) => (
          <IndicatorContainer key={$.id}>
            <Indicator role="listitem" name={$.name} />
            <span>{$.name}</span>
          </IndicatorContainer>
        ))}
        <IndicatorContainer>
          <Indicator role="listitem" name="last_season_lost" />
          <Indicator role="listitem" name="last_season_win" />
          <span>last season</span>
        </IndicatorContainer>
      </KeyList>
    </Container>
  );
}

export default KeyDescription;
